// extracted by mini-css-extract-plugin
export default {"question-box":"index_question-box__oBPIm"};